import { Input } from "antd";
import React, { FC } from "react";
import { FormErrors } from "../PreAuthIhx";

type BillDetailsProps = {
  formData: any;
  handleInputChange: any;
  errors: FormErrors;
  portalSubmission: boolean;
  calculateTotal: any;
  isApproved: any;
};

const BillDetails: FC<BillDetailsProps> = ({
  formData,
  handleInputChange,
  errors,
  portalSubmission,
  calculateTotal,
  isApproved,
}) => {
  return (
    <div>
      <div
        style={{
          textDecoration: "underline",
          fontSize: "16px",
          margin: "16px 0",
          fontWeight: "bold",
        }}
      >
        Bill Details
      </div>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(6, 1fr)",
          // padding: "15px 55px",
          gap: 20,
        }}
      >
        <div>
          <label>Package</label>
          <Input
            value={formData.package}
            onChange={(e) => handleInputChange("package", e.target.value)}
            placeholder="Enter Detail"
            min="0"
            style={{ width: "100%", marginTop: "10px" }}
            // disabled={portalSubmission || isApproved}
            disabled={portalSubmission}
          />
          {errors.package && (
            <div style={{ color: "red", fontSize: "12px" }}>
              {errors.package}
            </div>
          )}
        </div>
        <div>
          <label>
            ROOM & NURSING CHARGE <span style={{ color: "red" }}>*</span>
          </label>
          <Input
            value={formData.roomRentAndNursingCharges}
            onChange={(e) =>
              handleInputChange("roomRentAndNursingCharges", e.target.value)
            }
            placeholder="Enter Detail"
            style={{ width: "100%", marginTop: "10px" }}
            status={errors.roomRentAndNursingCharges ? "error" : ""}
            min="0"
            // disabled={portalSubmission || isApproved}
            disabled={portalSubmission}
          />
          {errors.roomRentAndNursingCharges && (
            <div style={{ color: "red", fontSize: "12px" }}>
              {errors.roomRentAndNursingCharges}
            </div>
          )}
        </div>
        <div>
          <label>CONSULTATION</label>
          <Input
            value={formData.consultation}
            onChange={(e) => handleInputChange("consultation", e.target.value)}
            placeholder="Enter Detail"
            style={{ width: "100%", marginTop: "10px" }}
            min="0"
            // disabled={portalSubmission || isApproved}
            disabled={portalSubmission}
          />
          {errors.consultation && (
            <div style={{ color: "red", fontSize: "12px" }}>
              {errors.consultation}
            </div>
          )}
        </div>
        <div>
          <label>OT CHARGES</label>
          <Input
            value={formData.otCharges}
            onChange={(e) => handleInputChange("otCharges", e.target.value)}
            placeholder="Enter Detail"
            style={{ width: "100%", marginTop: "10px" }}
            min="0"
            // disabled={portalSubmission || isApproved}
            disabled={portalSubmission}
          />
          {errors.otCharges && (
            <div style={{ color: "red", fontSize: "12px" }}>
              {errors.otCharges}
            </div>
          )}
        </div>
        <div>
          <label>SURGEON & ANESTHETIST</label>
          <Input
            value={formData.surgeonAndAnesthetist}
            onChange={(e) =>
              handleInputChange("surgeonAndAnesthetist", e.target.value)
            }
            placeholder="Enter Detail"
            style={{ width: "100%", marginTop: "10px" }}
            min="0"
            // disabled={portalSubmission || isApproved}
            disabled={portalSubmission}
          />
          {errors.surgeonAndAnesthetist && (
            <div style={{ color: "red", fontSize: "12px" }}>
              {errors.surgeonAndAnesthetist}
            </div>
          )}
        </div>
        <div>
          <label>INVESTIGATION</label>
          <Input
            value={formData.investigation}
            onChange={(e) => handleInputChange("investigation", e.target.value)}
            placeholder="Enter Detail"
            style={{ width: "100%", marginTop: "10px" }}
            min="0"
            // disabled={portalSubmission || isApproved}
            disabled={portalSubmission}
          />
          {errors.investigation && (
            <div style={{ color: "red", fontSize: "12px" }}>
              {errors.investigation}
            </div>
          )}
        </div>
        <div>
          <label>MEDICINE & CONSUMABLES</label>
          <Input
            value={formData.medicineAndConsumables}
            onChange={(e) =>
              handleInputChange("medicineAndConsumables", e.target.value)
            }
            placeholder="Enter Detail"
            style={{ width: "100%", marginTop: "10px" }}
            min="0"
            // disabled={portalSubmission || isApproved}
            disabled={portalSubmission}
          />
          {errors.medicineAndConsumables && (
            <div style={{ color: "red", fontSize: "12px" }}>
              {errors.medicineAndConsumables}
            </div>
          )}
        </div>
        <div>
          <label>
            OTHER HOSPITAL EXPENSES <span style={{ color: "red" }}>*</span>
          </label>
          <Input
            value={formData.otherHospitalExpense}
            onChange={(e) =>
              handleInputChange("otherHospitalExpense", e.target.value)
            }
            placeholder="Enter Detail"
            style={{ width: "100%", marginTop: "10px" }}
            status={errors.otherHospitalExpense ? "error" : ""}
            min="0"
            // disabled={portalSubmission || isApproved}
            disabled={portalSubmission}
          />
          {errors.otherHospitalExpense && (
            <div style={{ color: "red", fontSize: "12px" }}>
              {errors.otherHospitalExpense}
            </div>
          )}
        </div>

        <div>
          <label>Total</label>
          <h3 style={{ marginTop: "0.5rem" }}>₹ {calculateTotal()} /-</h3>
        </div>
      </div>
    </div>
  );
};

export default BillDetails;
